export default __webpack_public_path__ + "static/media/m_engineering_card21_2.16779a56.png";